(() => {
  var ProductVariantContent = class extends HTMLElement {
    constructor() {
      super();
    }
    
    connectedCallback() {
      this.ready = false;
      this.loaded = false;
      this.interval = setInterval(this.intervalCheck.bind(this), 100);
      window.onload = () => {
        window.dispatchEvent(new CustomEvent('content:onloaded'));
      };
      if (this.dataset.isQuickView == "true") {
        document.querySelectorAll('.drawer__content product-variants [data-skeleton]').forEach(e => e.remove());
        if (document.querySelector('.drawer__content product-variants .product-variant-inputs')) {
          document.querySelector('.drawer__content product-variants .product-variant-inputs').classList.remove('hidden');
        } else if (document.querySelector('.popover product-variants .product-variant-inputs')) {
          document.querySelector('.popover product-variants .product-variant-inputs').classList.remove('hidden');
        }
        window.addEventListener("variant:changed", this.handleChange.bind(this));
        this.ready = true;
      } else if (this.dataset.isProductItem == "true") {
        clearInterval(this.interval);
        window.addEventListener("variant:changed", this.handleChange.bind(this));
        this.querySelectorAll('[data-skeleton]').forEach(e => e.remove());
        this.querySelector(`.${this.dataset.target}[data-id="${this.dataset.default}"]`).classList.toggle('hidden');
        this.loaded = true;
        this.ready = true;
      } else {
        window.addEventListener("content:onloaded", () => {
          if (this.dataset.isProductItem != "true" && this.dataset.isQuickView != "true") {
            document.querySelectorAll('product-variants [data-skeleton]').forEach(e => e.remove());
            document.querySelector('product-variants .product-variant-inputs')?.classList.remove('hidden');
            window.addEventListener("variant:changed", this.handleChange.bind(this));
            this.ready = true;
          }
        });
      }
      window.addEventListener("product-item:variant:changed", this.handleChange.bind(this));
    }
    
    intervalCheck() {
      if (this.ready) {
        window.dispatchEvent(new CustomEvent('variant:changed', {
          bubbles: true,
          detail: { variant: {
            id: this.dataset.default
          } }
        }));
      }
    }
    
    handleChange(e) {
      if (this.loaded == false) {
        this.loaded = true;
        clearInterval(this.interval);
        this.querySelectorAll('[data-skeleton]').forEach(e => e.remove());
      }
      let hasCurrentVariantChangeID = this.querySelectorAll(`.${this.dataset.target}[data-id="${e.detail.variant.id}"]`);
      if (hasCurrentVariantChangeID.length) {
        this.querySelectorAll(`.${this.dataset.target}:not(.hidden)`)
          .forEach((element) => element.classList.add("hidden"));
        this.querySelector(`.${this.dataset.target}[data-id="${e.detail.variant.id}"]`).classList.remove('hidden');
      }
    }
  };

  window.customElements.define(
    "product-variant-content",
    ProductVariantContent
  );
})();
